<div class="centered">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
